import {keys} from 'ts-transformer-keys';

import {FilterMatchMode} from 'primereact/api';

import {
    DataAggregator,
    DataDescriptor
} from '~/shared/src/utilities/dataStructure';
import {Format} from '~/shared/src/utilities/format';
import {
    Messages,
    Styles
} from '~/shared/src/utilities/dataExtraction';
import {PropertyValueType} from '~/shared/src/mm/PropertySet';
import {EditorConfig} from '~/shared/src/utilities/editorConfig';
import {FilterConfig} from '~/shared/src/utilities/filterConfig';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


/*** CFG:Column ***/
export type Column = {
    data : {
        id : number;
        key : string;
        name : string;

        aggregateFunction? : DataAggregator;
        alignment? : 'left' | 'center' | 'right';
        attributePath? : string;
        defaultValue? : AttributeValue;
        editorConfig?: EditorConfig;
        filterConfig?: FilterConfig;
        filterIfHidden? : boolean;
        filterIsFixed? : boolean;
        filterOperator? : 'empty' | 'notEmpty' | 'notStartsWith' | 'notEndsWith' | 'notIn' | Exclude<FilterMatchMode, 'between' | 'dateIs' | 'dateIsNot' | 'dateBefore' | 'dateAfter'>;
        filterValue? : string;
        isEditable? : boolean;
        isFilterable? : boolean;
        isHidable? : boolean;
        isHidden? : boolean;
        isSearchColumn? : boolean;
        isSortable?: boolean;
        loadIfHidden? : boolean;
        order? : number;
        queryFieldName? : string;
        sortDirection? : SortDirection;
        sortOrder? : number;
        validator? : string;
        valueType : PropertyValueType;
        width? : number;
        widthMax? : number;
        widthMin? : number;
    };
    dataDescriptor? : DataDescriptor;
    format? : Format;
    messages? : Messages;
    panelConfigIds? : number[];
    permissions? : GroupPermissions;
    styles? : Styles;
};

export const columnDataProps = keys<Column['data']>();
export const columnProps = keys<Column>();
export const requiredColumnProps = keys<RequiredOf<Column>>();
